export default "__VITE_ASSET__By5y8Jue__"